'use es6';

import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIFieldset from 'UIComponents/form/UIFieldset';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { VideoParamTypes } from '../../constants/video';
import { jsx as _jsx } from "react/jsx-runtime";
const renderVideoParamCheckbox = (paramType, value, onChange) => {
  return /*#__PURE__*/_jsx(UICheckbox, {
    checked: !!value,
    onChange: () => onChange(paramType, !value),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `RichTextLib.video.advanced.params.${paramType}`
    })
  }, `video-param-${paramType}`);
};
const propTypes = {
  className: PropTypes.string,
  videoParams: PropTypes.object.isRequired,
  onVideoParamChange: PropTypes.func.isRequired
};
function VideoPopoverAdvancedControls(props) {
  const {
    className,
    videoParams,
    onVideoParamChange
  } = props;
  const handleVideoParamChange = (paramType, checked) => {
    onVideoParamChange(Object.assign({}, videoParams, {
      [paramType]: checked
    }));
  };
  return /*#__PURE__*/_jsx(UIFieldset, {
    className: className,
    _size: "small",
    children: /*#__PURE__*/_jsx(UIFormControl, {
      label: I18n.text('RichTextLib.video.advanced.paramsLabel'),
      tooltip: I18n.text('RichTextLib.video.advanced.paramsHelp'),
      tooltipPlacement: "top right",
      children: /*#__PURE__*/_jsx(UIToggleGroup, {
        name: "video-params",
        children: Object.values(VideoParamTypes).map(paramType => renderVideoParamCheckbox(paramType, videoParams[paramType], handleVideoParamChange))
      })
    })
  });
}
VideoPopoverAdvancedControls.propTypes = propTypes;
VideoPopoverAdvancedControls.displayName = 'VideoPopoverAdvancedControls';
export default VideoPopoverAdvancedControls;